// Angular
import { Component, ViewEncapsulation, OnInit, Input, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

// Rxjs
import { Store } from '@ngrx/store';

// NgRx
import * as LayoutsActions from '../../store/layout/layout.actions';

// Store
import * as SignupActions from '../../store/access/signup/signup.actions';
import * as RouterActions from '../../store/router/router.actions';
import { AppState } from '../../store';

// Models
import { NewUser } from '../../shared/models/b2b/newUser';

// Helpers
import { Subscriber } from '../../shared/lib/helpers/subscriber';
import { isKeyNumber } from '../../shared/lib/helpers/utils';
import { SignupService } from '../../shared/services/b2b/signup.service';
import { ProvinceOption, ProvincesService } from '../../shared/services/b2b/provinces.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-signup-new',
    templateUrl: './signup-new.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SignupNewComponent extends Subscriber implements OnInit, OnChanges {
    @Input() logo;

    logoUrl: SafeUrl = '';

    // Model
    newUser: NewUser;

    // Form
    signupForm: FormGroup;
    // authorization: boolean;

    // Messages
    typeOKMsg: boolean;
    msg: string;

    // Flags
    loading: boolean;
    sendIt: boolean;
    sending: boolean;
    sendIntent: boolean;

    myForm: any;

    captchaResolved = false;
    provinces: ProvinceOption[] = [];

    constructor(
        private store: Store<AppState>,
        private fb: FormBuilder,
        private sanitize: DomSanitizer,
        private signupService: SignupService,
        private provincesService: ProvincesService
    ) {
        // Execute base class contructor
        super();

        // this.store.dispatch(new RememberPassActions.Reset());
        this.store.dispatch(new SignupActions.DoReset());

        this.subscribeSignup();
    }

    subscribeSignup(): void {
        this.addSubscription(
            this.store
                .select((state) => state.signup)
                .subscribe((res) => {
                    if (res && res.result) {
                        if (res.result === true) {
                            this.sendIt = true;
                            this.showMsg(res.result.value, true);
                            this.formReset();
                            // this.store.dispatch(new RouterActions.Go({
                            //     path: ['login']
                            // }));
                        } else {
                            this.showMsg(res.result.value, false);
                        }
                    } else {
                        if (res.error) {
                            this.showMsg(res.error.value, false);
                        }
                    }

                    this.loading = false;
                })
        );
    }

    ngOnInit(): void {
        this.createForm();
        this.provinces = this.provincesService.getProvinces();
        // this.authorization = false;onsu
    }

    ngOnChanges() {
        if (this.logo) {
            this.logoUrl = this.sanitize.bypassSecurityTrustUrl(this.logo);
        }
    }

    createForm(): void {
        const emailPattern =
            /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
        const zipPattern = /^[0-9]*$/;

        this.signupForm = this.fb.group({
            Company: ['', Validators.required],
            LEADCF39: ['', Validators.required],
            'First Name': ['', Validators.required],
            'Last Name': ['', Validators.required],
            LEADCF8: [
                '',
                [
                    Validators.required,
                    Validators.minLength(9),
                    Validators.maxLength(9),
                    Validators.pattern('^([0-9]{8}[A-Za-z]|[A-Za-z][0-9]{7}[A-Za-z0-9])$')
                ]
            ],
            Street: ['', Validators.required],
            ZipCode: ['', [Validators.required, Validators.pattern(zipPattern)]],
            City: ['', Validators.required],
            State: ['', Validators.required],
            Phone: ['', Validators.required],
            Email: ['', [Validators.required, Validators.pattern(emailPattern)]],
            privacyTool: ['', Validators.requiredTrue],
            Autorizo: ['']
            // GarageType: ['', Validators.required],
            // WheelType: ['', Validators.required],
            // HowMetUs: ['', Validators.required],
            // Volume: [''],
            // LEADCF101: [''],
            // 'Email Opt Out': ['']
        });
    }

    clickConditions(ev): void {
        /* ev.preventDefault();
        this.utilsService.openModalConditions();
        this.checkCloseMenu();*/
    }

    // setAuthorization(value: boolean): void {
    //      this.signupForm.controls['authorization_check'].setValue(value);
    //      this.authorization = this.signupForm.get('authorization_check').value;
    // }

    checkCloseMenu(): void {
        this.store.dispatch(new LayoutsActions.CloseMenu());
    }

    isFieldValid(field: string): boolean {
        if (!this.sendIntent) {
            return false;
        }
        return this.signupForm.get(field).invalid;

        // return this.signupForm.get(field).invalid
        //     && (this.signupForm.get(field).dirty || this.signupForm.get(field).touched);
    }

    sendForm(ev): void {
        ev.preventDefault();

        this.sendIntent = true;
        if (this.sending) {
            return;
        }
        this.sending = true;

        if (this.signupForm.valid && this.captchaResolved) {
            this.newUser = this.signupForm.value;
            this.signup();
        } else {
            this.validateAllFormFields();
            this.loading = false;
            this.sending = false;
        }
    }

    showMsg(msg: string, success: boolean): void {
        this.typeOKMsg = success;
        this.msg = msg;
    }

    signup(): void {
        const formValue: any = this.signupForm.value;
        const payload = {
            company_name: formValue.LEADCF39 || '',
            company_fiscal_name: formValue.Company || '',
            company_cif: formValue.LEADCF8 || '',
            lead_name: formValue['First Name'] || '',
            lead_lastname: formValue['Last Name'] || '',
            lead_address: formValue.Street || '',
            lead_postal_code: formValue.ZipCode || '',
            lead_city: formValue.City || '',
            lead_province: formValue.State || '',
            lead_email: formValue.Email || '',
            lead_phone: formValue.Phone || '',
            accept_gdpr: formValue.privacyTool ? '1' : '0',
            accept_product_offers: formValue.Autorizo ? '1' : '0',
            country_iso: 'ES'
        };

        try {
            this.signupService.createCandidate(payload).subscribe(
                () => {
                    this.sendIt = true;
                    this.showMsg('', true);
                    this.formReset();
                    this.sending = false;
                },
                (error) => {
                    const errorMsg =
                        error instanceof HttpErrorResponse
                            ? error.error
                            : error instanceof Error
                              ? error.message
                              : String(error);
                    this.showMsg('Error al enviar el formulario.', false);
                    console.error(errorMsg);
                    this.sending = false;
                    throw error;
                }
            );
        } catch (error) {
            const errorMsg = error instanceof Error ? error.message : String(error);
            this.showMsg('Error al enviar el formulario.', false);
            console.error(errorMsg);
            this.sending = false;
            throw error;
        }
    }

    backToLogin(ev): void {
        ev.preventDefault();

        // this.webtrekk.registerEvent();

        this.store.dispatch(
            new RouterActions.Go({
                path: ['login']
            })
        );
    }

    formReset(): void {
        // TODO: Not working with uni-components
        this.signupForm.reset();
        this.sendIntent = false;

        Object.keys(this.signupForm.controls).forEach((field) => {
            const control = this.signupForm.get(field);
            control.markAsPristine();
            control.markAsUntouched();
            control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        });
    }

    validateAllFormFields(): void {
        Object.keys(this.signupForm.controls).forEach((field) => {
            const control = this.signupForm.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    }

    onKeyPressFieldNumber(ev) {
        // console.log("ev: ", ev.keyCode);
        // console.log("val: ", allows_arr.indexOf(ev.keyCode));
        return isKeyNumber(ev.keyCode);
    }

    onCaptchaVerify() {
        this.captchaResolved = true;
    }

    onCaptchaExpired() {
        this.captchaResolved = false;
    }

    onCaptchaError() {
        this.captchaResolved = false;
    }
}
